import BehaviorConfig from '@/models/app-config/behavior/behavior'
import {
  defaultSignUpPageParts,
  fitowaSignupPageParts,
  ledianSignupPageParts,
  mycolorSignUpPageParts,
  SignUpPageParts,
  vilbSignUpPageParts,
} from './page-parts'

export function createSignUpPageParts(behavior: BehaviorConfig): SignUpPageParts {
  if (behavior.isVilb) return vilbSignUpPageParts

  if (behavior.isFitowa) return fitowaSignupPageParts

  if (behavior.isMyColor) return mycolorSignUpPageParts

  if (behavior.isLedian) return ledianSignupPageParts

  return defaultSignUpPageParts
}
